import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { useRoute } from 'vue-router';
import UpdateDocument from '@/components/disposable/UpdateDocument.vue';
import { DocumentType } from '@/model/document';


export default /*#__PURE__*/_defineComponent({
  __name: 'UpdateIllustrationView',
  setup(__props) {

const route = useRoute();
const authorID = route.params.authorID as string;
const documentUUID = route.params.documentUUID as string;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UpdateDocument, {
    "document-type": _unref(DocumentType).Illustration,
    metadataID: _unref(authorID),
    documentUUID: _unref(documentUUID)
  }, null, 8, ["document-type", "metadataID", "documentUUID"]))
}
}

})